import { SET_CHALLENGE_BANNER, SET_COMPLETE_CHALLENGE_BANNER, SET_COMPLETE_QUIZ_BANNER, SET_DOWNLOAD_CERTIFICATE_BANNER, SET_EXTEND_CHALLENGE_BANNER, SET_JES_BANNER, SET_JES_CALCULATED_BANNER, SET_JES_IS_NOT_CALCULATED_BANNER, SET_MARKETPLACE_BANNER, SET_START_CHALLENGE_BANNER, SET_UNLOCK_CERTIFICATE_BANNER, SET_UPGRADE_BANNER } from '../actions/types';

const initialState = {
    showQuizBanner: true,
    showStartChallengeBanner: true,
    showCompleteChallengeBanner: true,
    showExtendChallengeBanner: true,
    showJesCalculatedBanner: true,
    showJesIsNotCalculatedBanner: true,
    showDownloadCertificateBanner: true,
    showUnlockCertificateBanner: true,
    showUpgradeBanner : true

};



export default function (state = initialState, action) {
    switch (action.type) {
        case SET_COMPLETE_QUIZ_BANNER:
            return {
                ...state,
                showQuizBanner: action.payload
            }
        case SET_START_CHALLENGE_BANNER:
            return {
                ...state,
                showStartChallengeBanner: action.payload
            }
        case SET_COMPLETE_CHALLENGE_BANNER:
            return {
                ...state,
                showCompleteChallengeBanner: action.payload
            }
        case SET_EXTEND_CHALLENGE_BANNER:
            return {
                ...state,
                showExtendChallengeBanner : action.payload
            }
        case SET_UNLOCK_CERTIFICATE_BANNER:
            return {
                ...state,
                showUnlockCertificateBanner : action.payload
            }
        case SET_UPGRADE_BANNER : {
            return{
                ...state,
                showUpgradeBanner : action.payload
            }
        }
        case SET_JES_CALCULATED_BANNER:
            return {
                ...state,
                showJesCalculatedBanner : action.payload
            }
        case SET_JES_IS_NOT_CALCULATED_BANNER:
            return {
                ...state,
                showJesIsNotCalculatedBanner : action.payload
            }
        case SET_DOWNLOAD_CERTIFICATE_BANNER : 
            return{
                ...state , 
                showDownloadCertificateBanner : action.payload
            }
        default:
            return state;
    }
}